import React from 'react';
import { useCurrentFrame, interpolate, AbsoluteFill } from 'remotion';
import { COLORS } from '../constants';
import { PrixiaLogoBig } from '../components/PrixiaLogo';

export const IntroScene: React.FC = () => {
  const frame = useCurrentFrame();

  const glowSize = interpolate(frame, [10, 50], [0, 350], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });
  const glowOpacity = interpolate(frame, [10, 30, 70, 90], [0, 0.3, 0.2, 0], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });
  const fadeOut = interpolate(frame, [70, 90], [1, 0], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });

  const particles = Array.from({ length: 25 }, (_, i) => {
    const angle = (i / 25) * Math.PI * 2;
    const speed = 1 + (i % 3) * 0.5;
    const radius = interpolate(frame, [8, 60], [0, 150 + i * 6], {
      extrapolateRight: 'clamp',
      extrapolateLeft: 'clamp',
    });
    const colors = [COLORS.brandIndigo, COLORS.brandTeal, COLORS.brandAmber];
    return {
      x: Math.cos(angle + frame * 0.01 * speed) * radius,
      y: Math.sin(angle + frame * 0.01 * speed) * radius,
      opacity: interpolate(frame, [8, 25, 65, 85], [0, 0.4, 0.2, 0], {
        extrapolateRight: 'clamp',
        extrapolateLeft: 'clamp',
      }),
      size: 2 + (i % 3),
      color: colors[i % 3],
    };
  });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: COLORS.bg,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: fadeOut,
      }}
    >
      <div
        style={{
          position: 'absolute',
          width: glowSize,
          height: glowSize,
          borderRadius: '50%',
          background: `radial-gradient(circle, ${COLORS.brandIndigo}18, ${COLORS.brandTeal}0C, transparent)`,
          filter: 'blur(40px)',
          opacity: glowOpacity,
        }}
      />

      {particles.map((p, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            left: `calc(50% + ${p.x}px)`,
            top: `calc(50% + ${p.y}px)`,
            width: p.size,
            height: p.size,
            borderRadius: '50%',
            backgroundColor: p.color,
            opacity: p.opacity,
          }}
        />
      ))}

      <div style={{ zIndex: 10 }}>
        <PrixiaLogoBig startFrame={5} scale={3} />
      </div>
    </AbsoluteFill>
  );
};
